import { useEffect, useRef } from 'react';

const WINDOW_MS = 10000;
const SAMPLE_MS = 50;
const RANGE = 50;

// Scrolling graph of cents deviation over the last 10 seconds.
export const PitchHistory = ({ cents }) => {
  const canvasRef = useRef(null);
  const centsRef = useRef(cents);
  centsRef.current = cents;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const samples = [];
    let lastSample = 0;
    let raf;

    const draw = (now) => {
      if (now - lastSample >= SAMPLE_MS) {
        lastSample = now;
        samples.push({ t: now, c: centsRef.current });
        while (samples.length && now - samples[0].t > WINDOW_MS) samples.shift();
      }
      const dpr = window.devicePixelRatio || 1;
      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      if (canvas.width !== Math.round(w * dpr)) { canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      const y = (c) => h / 2 - (Math.max(-RANGE, Math.min(RANGE, c)) / RANGE) * (h / 2 - 4);
      ctx.fillStyle = 'rgba(52,211,153,0.08)';
      ctx.fillRect(0, y(5), w, y(-5) - y(5));
      ctx.strokeStyle = 'rgba(255,255,255,0.08)';
      ctx.beginPath(); ctx.moveTo(0, h / 2); ctx.lineTo(w, h / 2); ctx.stroke();
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';
      let prev = null;
      for (const s of samples) {
        if (s.c === null || s.c === undefined) { prev = null; continue; }
        const x = w - ((now - s.t) / WINDOW_MS) * w;
        const py = y(s.c);
        if (prev) {
          ctx.strokeStyle = Math.abs(s.c) <= 5 ? '#34d399' : '#f472b6';
          ctx.beginPath(); ctx.moveTo(prev.x, prev.y); ctx.lineTo(x, py); ctx.stroke();
        }
        prev = { x, y: py };
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div data-testid="tuner-history" className="w-full max-w-xl mx-auto">
      <div className="flex justify-between text-[10px] uppercase tracking-[0.3em] text-white/40 mb-1">
        <span>Storico · 10 s</span>
        <span>±50 cent</span>
      </div>
      <div className="relative h-20 rounded-xl bg-[#0A0A0A] border border-white/5 overflow-hidden">
        <canvas data-testid="tuner-history-canvas" ref={canvasRef} className="absolute inset-0 w-full h-full" />
        <span className="absolute left-2 top-1 text-[9px] font-mono text-white/30">#</span>
        <span className="absolute left-2 bottom-1 text-[9px] font-mono text-white/30">♭</span>
      </div>
    </div>
  );
};
